import { PencilIcon } from '@heroicons/react/20/solid';
import { PropsWithChildren } from 'react';
import { Button, Stack } from 'ui-components';

type Props = PropsWithChildren<{
  onClick: () => void;
}>;

export default function EditInfoLink({ children, onClick }: Props): JSX.Element {
  return (
    <Button
      className="inline-block p-0 border-primary-60 border-b border-gray-400 italic hover:border-primary-800 hover:bg-primary-600/10"
      fill="ghost"
      size="small"
      type="button"
      onClick={onClick}
    >
      <Stack direction="row" gap={1}>
        {children} <PencilIcon className="h-4 w-4" />
      </Stack>
    </Button>
  );
}
